import styled from "@emotion/styled";
import { Box, Button, IconButton, InputBase, Typography } from "@mui/material";
import React from "react";
import { searchIcon } from "../../../assets";

const FlexRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
});
const FlexColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const StyledButton = styled(Button)(({ theme, colors, selected }) => ({
  backgroundColor: selected ? colors.primary[500] : colors.whiteAccent[900],
  color: selected ? colors.whiteAccent[900] : colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "49%",
  height: "53px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

export const ScholarPresets = ({ colors, theme }) => {
  return (
    <FlexColumn
      // className={`${classes.flexColumn}`}
      width="90%"
      height={350}
      style={{
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: 50,
      }}
    >
      <Typography
        variant="subtitle2"
        color={colors.black[500]}
        fontWeight={500}
      >
        Customize Scholar Presets
      </Typography>
      <FlexRow
        //   className={`${classes.flexRow}`}
        width="100%"
        style={{ justifyContent: "space-between" }}
      >
        <FlexColumn
          sx={{
            height: "234px",
            width: "49%",
            border: "1px solid #E8ECF5",
            backgroundColor: "#ffffff",
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "20%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderBottom: "2px solid #E8ECF5",
            }}
          >
            <Typography
              variant="body1"
              color={colors.black[500]}
              fontWeight={400}
            >
              Customize Scholar Presets
            </Typography>
          </Box>

          <Box
            sx={{
              width: "100%",
              height: "80%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#F9F8FD",
              borderTop: "2px solid #E8ECF5",
            }}
          >
            <Typography
              variant="body1"
              color={colors.black[500]}
              fontWeight={400}
            >
              mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG
            </Typography>
          </Box>
        </FlexColumn>
        <FlexColumn
          sx={{
            height: "234px",
            width: "49%",
            border: "1px solid #E8ECF5",
            backgroundColor: "#ffffff",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "20%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderBottom: "2px solid #E8ECF5",
            }}
          >
            <Typography
              variant="body1"
              color={colors.black[500]}
              fontWeight={400}
            >
              Split
            </Typography>
          </Box>
          <Box
            backgroundColor={theme.palette.secondary.dark}
            borderRadius="6px"
            sx={{ border: "1px solid #F3F5F9" }}
          >
            <IconButton type="button" sx={{ p: 1 }}>
              <img src={searchIcon} alt="search" />
            </IconButton>
            <InputBase
              sx={{ ml: 2, flex: 1, fontSize: "14px" }}
              placeholder="Search By Game"
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "80%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#F9F8FD",
              borderTop: "2px solid #E8ECF5",
            }}
          >
            <Typography
              variant="body1"
              color={colors.black[500]}
              fontWeight={400}
            >
              mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG
            </Typography>
          </Box>
        </FlexColumn>
      </FlexRow>

      <FlexRow
        width="100%"
        sx={{
          justifyContent: "space-between",
        }}
      >
        <StyledButton onClick={() => console.log("update")} colors={colors}>
          Update
        </StyledButton>
        <StyledButton onClick={() => console.log("update")} colors={colors}>
          Update
        </StyledButton>
      </FlexRow>
    </FlexColumn>
  );
};
